// extracted by mini-css-extract-plugin
module.exports = {"root":"_1561e4d8","slider":"_47740b89","image":"_2b4c6590","viewport":"_f98f4e1f","sliderContainer":"_515241a2","slide":"_7b8520ba","navigationButton":"_21d6ea3c"};